document.addEventListener('DOMContentLoaded', () => {

    // ---------- WHEY FRACTIONS GRAPH ----------
    document.querySelectorAll('[data-whey-fractions-graph]').forEach((graph) => {
        if (!graph || graph.dataset.gsapInit) return;
        graph.dataset.gsapInit = 'true';

        const scroller = graph.closest('[data-scroll-container]') || undefined;
        const paths = graph.querySelectorAll('[data-gsap-grow]');
        const graphDatas = graph.querySelectorAll('[data-graph-data], [data-graph-data-2]');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: graph,
                scroller,
                start: 'top 80%',
                end: 'top 20%',
                delay: 0.2,
            },
        });


        tl.from(paths, {
            scale: 0.9,
            opacity: 0,
            duration: 0.6,
            ease: 'smooth',
            stagger: 0.05,
            svgOrigin: '614.5 614.5',
        })
        tl.from(graphDatas, {
            opacity: 0,
            y: 10,
            duration: 0.6,
            ease: 'smooth',
            stagger: 0.05,
            delay: 0.15,
        }, "<");

    });



    // ---------- GLOBAL GRAPH ANIMATIONS ----------
    document.querySelectorAll('[data-shares-graph]').forEach((graph) => {
        if (!graph || graph.dataset.gsapInit) return;
        graph.dataset.gsapInit = 'true';

        const scroller = graph.closest('[data-scroll-container]') || undefined;
        const bars = graph.querySelectorAll('[data-gsap-grow]');
        bars.forEach((bar) => {
            bar.style.overflow = 'hidden';
        });

        const values = graph.querySelectorAll('[data-gsap-value]');
        values.forEach((value) => {
            value.innerHTML = '0%'
        });

        values.forEach((value) => {
            const finalValue = parseInt(value.getAttribute('data-gsap-value'), 10) || 0;
            gsap.to(value, {
                innerText: finalValue + '%',
                duration: 1.5,
                delay: 0.2,
                snap: { innerText: 1 },
                ease: 'smooth',
                stagger: 0.05,
            });
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: graph,
                scroller,
                start: 'top 80%',
                end: 'top 20%',
            },
        });

        tl.from(bars, {
            width: 0,
            duration: 1.5,
            delay: 0.1,
            ease: 'smooth',
            stagger: 0.1,
        });

    });

    // ---------- STROKE GRAPH ----------
    document.querySelectorAll('[data-stroke-graph]').forEach((container) => {
        if (!container || container.dataset.gsapInit) return;
        container.dataset.gsapInit = 'true';

        const scroller = container.closest('[data-scroll-container]') || undefined;
        const paths = container.querySelectorAll('[data-gsap-grow]');

        let allGood = true;

        paths.forEach((path) => {
            try {
                const length = path.getTotalLength();
                gsap.set(path, {
                    strokeDasharray: length,
                    strokeDashoffset: length,
                });
            } catch (e) {
                allGood = false;
            }
        });

        if (!allGood) return;

        gsap.to(paths, {
            strokeDashoffset: 0,
            duration: 2.25,
            ease: 'smooth',
            stagger: 0.2,
            delay: 0.2,
            scrollTrigger: {
                trigger: container,
                scroller,
                start: 'top 80%',
                end: 'top 20%',
            },
        });
    });


    // ---------- AA GRAPH ----------
    document.querySelectorAll('[data-aa-graph]').forEach((graph) => {
        if (!graph || graph.dataset.gsapInit) return;
        graph.dataset.gsapInit = 'true';

        const scroller = graph.closest('[data-scroll-container]') || undefined;
        const bars = graph.querySelectorAll('[data-gsap-grow]');
        const values = graph.querySelectorAll('[data-gsap-value]');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: graph,
                scroller,
                delay: 0.2,
                start: 'top 80%',
                end: 'top 20%',
            },
        });

        tl.from(bars, {
            height: 0,
            duration: 1.5,
            delay: 0.2,
            ease: 'smooth',
            stagger: 0.05,
        });

        values.forEach((el) => {
            const end = parseFloat(el.dataset.gsapValue || el.textContent);
            const obj = { val: 0 };

            tl.to(obj, {
                val: end,
                duration: 1.2,
                ease: 'smooth',
                onUpdate: () => {
                    el.textContent = Math.round(obj.val);
                },
            }, '<');
        });
    });


    // ---------- TASTE TEST GRAPH ----------
    document.querySelectorAll('[data-taste-test-graph]').forEach((graph) => {
        if (!graph || graph.dataset.gsapInit) return;
        graph.dataset.gsapInit = 'true';

        const scroller = graph.closest('[data-scroll-container]') || undefined;
        const bars = graph.querySelectorAll('[data-gsap-grow]');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: graph,
                scroller,
                start: 'top 80%',
                end: 'top 20%',
                delay: 0.2,
            },
        });

        tl.from(bars, {
            height: 0,
            duration: 1.2,
            delay: 0.2,
            ease: 'smooth',
            stagger: 0.05,
        });
    });


    // ---------- GLOBAL REFRESH (important for modals) ----------
    requestAnimationFrame(() => {
        ScrollTrigger.refresh();
    });

});